import React from "react";
import QuantitySelector from "../../assets/QuantitySelector";

export default function AddOnList({ addOns, featureColor = "#000000" }) {

	// console.log("Add ons", addOns);

	return <div className="addOns">
		{addOns.map(({ addOn }) => {
			return <div className="addOn flexy v-middle" key={addOn.id}>
				<div className="addOn-inner featureFont">
					<span>
						Add {addOn.name}
					</span>
					{Boolean(addOn.price) && <span className="price" style={{
						color: featureColor
					}}>
						+£{(addOn.price / 100).toFixed(2)}
					</span>}
				</div>
				<div className="text-right">
					<QuantitySelector
						value={0}
						onChange={val => {

						}}
					/>
				</div>
			</div>
		})}
	</div>
}